import separatedElements from 'core/components/common/separatedElements';
import { LinksConsumer } from 'core/components/linksContext';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import { formatTimeSpanHHMM, getRichContent } from 'core/utils';
import React from 'react';
import { Account, EventRecord, Lecturer, Material } from 'site/graphql';
import TeacherIcon from '../../../../svg/user.svg';
import { formItemCardStyles } from './formItemCardStyles';

type IPrivateProductSeminarCardProps = {
    title: string;
    description: string;
    lecturers: (Pick<Lecturer, 'id'> & { account: Pick<Account, 'id' | 'firstName' | 'lastName'> })[];
    record: Pick<EventRecord, 'id' | 'link'>;
    materials: Pick<Material, 'id' | 'link'>[];
    hours: number;
};

const PrivateProductSeminarCard: React.FC<IPrivateProductSeminarCardProps & WithStyles<typeof styles>> = ({
    classes,
    title,
    description,
    hours,
    lecturers,
    record,
    materials,
}) => (
    <div className={classes.root}>
        <div className={classes.content}>
            <h3 className={classes.title}>{title}</h3>
            <span className={classes.teachers}>
                <TeacherIcon className={classes.icon} />
                <LinksConsumer>
                    {links =>
                        separatedElements(lecturers, lect => (
                            <links.teacherDetail.Link
                                key={lect.id}
                                to={links.teacherDetail.url(lect.id)}
                                className={classes.teacher}
                            >
                                {lect.account.firstName} {lect.account.lastName}
                            </links.teacherDetail.Link>
                        ))
                    }
                </LinksConsumer>
            </span>
            {hours && <div className={classes.hours}>Продолжительность: {formatTimeSpanHHMM(hours)}</div>}
            <div className={classes.shortDesc} dangerouslySetInnerHTML={{ __html: getRichContent(description) }} />
            <div className={classes.addons}>
                {record && record.link && (
                    <a className={classes.addons__button} onClick={() => window.open(`${record.link}`, '_blank')}>
                        Видеозапись
                    </a>
                )}
                {materials && materials[0] && materials[0].link && (
                    <a className={classes.addons__button} onClick={() => window.open(`${materials[0].link}`, '_blank')}>
                        Материал
                    </a>
                )}
            </div>
        </div>
    </div>
);

const styles = (theme: ITheme) =>
    createStyles({
        ...formItemCardStyles(theme),
        greyRect: {
            background: '#cccccc',
            height: 175,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'default',
        },
        shortDesc: {
            flexGrow: 1,
            marginBottom: 0,
        },
    });

export default injectSheet(styles, 'PrivateProductSeminarCard')(PrivateProductSeminarCard);
